import { render, staticRenderFns } from "./loyaltyMomentCard.vue?vue&type=template&id=5a692f1f&"
import script from "./loyaltyMomentCard.vue?vue&type=script&lang=js&"
export * from "./loyaltyMomentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports